module.exports = __webpack_public_path__ + "static/img/WF.3ee6e5ad.svg";